import type { TFunction } from 'i18next';
import type { CampaignDraft } from './types';

// ─── La línea de la estimación de destinatarios (puro, con test) ────────────

/** «~N destinatarios · M sin correo registrado · K fallecidos en origen
 *  (excluidos)». Cada parte de excluidos aparece solo si es mayor que 0. */
export function estimateLine(
  draft: Pick<
    CampaignDraft,
    'estimatedCount' | 'estimatedExcludedNoEmail' | 'estimatedExcludedDeceased'
  >,
  t: TFunction,
): string {
  const noEmail = draft.estimatedExcludedNoEmail ?? 0;
  const deceased = draft.estimatedExcludedDeceased ?? 0;
  const parts = [t('campaign.estimate.recipients', { count: draft.estimatedCount ?? 0 })];
  if (noEmail > 0) parts.push(t('campaign.estimate.noEmail', { count: noEmail }));
  if (deceased > 0) parts.push(t('campaign.estimate.deceased', { count: deceased }));
  const line = parts.join(' · ');
  return noEmail + deceased > 0
    ? `${line} ${t('campaign.estimate.excludedSuffix', { count: noEmail + deceased })}`
    : line;
}
